import React from "react";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";

import request from "../../../utilities/requests";

const menuItems = Array.from({ length: 20 }, (_, i) => i + 1);

const NumberOfRounds = ({ pairingEvent }) => {
  const [rounds, setRounds] = React.useState(null);

  React.useEffect(() => {
    if (pairingEvent) {
      setRounds(pairingEvent.numberOfRounds);
    }
  }, [pairingEvent]);

  const handleChange = async (event) => {
    let newRounds = event.target.value;
    if (newRounds === rounds) {
      return;
    }

    const body = {
      pairingEventId: pairingEvent._id,
      update: {
        numberOfRounds: newRounds,
      },
    };

    const result = await request("pairingevent/update", "post", body);
    if (!result.success) {
      return;
    }
    setRounds(newRounds);
  };

  return (
    <FormControl style={{ width: 100 }} size="small">
      <InputLabel id="label">Rounds</InputLabel>
      <Select
        labelId="label"
        value={rounds ? rounds : 10}
        label="Rounds"
        onChange={handleChange}
      >
        {menuItems.map((item) => {
          return (
            <MenuItem key={`round${item}`} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default NumberOfRounds;
